import { render, staticRenderFns } from "./Boleta.vue?vue&type=template&id=0dca35f3&"
import script from "./Boleta.vue?vue&type=script&lang=js&"
export * from "./Boleta.vue?vue&type=script&lang=js&"
import style0 from "./Boleta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports